import React, { useState } from 'react';
import PasswordInput from './PasswordInput';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import { api } from '../services/api';

function Login() {
  const [username, setUsername] = useState('');
  const [senha, setSenha] = useState('');
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  // "Manter conectado": sessão de 30 dias em vez de 7 (o back decide pelo `manter_conectado`).
  const [manter, setManter] = useState(false);

  const navigate = useNavigate();
  const { login, isLogado } = useAuth();
  const toast = useToast();

  if (isLogado) return <Navigate to="/" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setErro('');
    setLoading(true);

    try {
      const data = await api.post('/auth/login', { username, password: senha, manter_conectado: manter });

      if (data.login === true) {
        login(data.user || {}, data.token);
        navigate(data.user?.troca_senha_obrigatoria ? '/TrocarSenha' : '/');
      } else {
        setErro(data.error || 'Credenciais inválidas.');
      }
    } catch (error) {
      setErro(error.message || 'Erro de conexão com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ds-auth-wrapper">
      <div className="ds-auth-card">
        <span className="ds-auth-accent" />
        <h2 className="ds-auth-title">Entrar</h2>
        <p className="ds-auth-subtitle">Acesse sua conta para continuar</p>

        <form className="ds-form" onSubmit={handleSubmit}>
          <div className="ds-form-group">
            <label className="ds-label" htmlFor="username">Usuário</label>
            <input
              id="username"
              className="ds-input"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Digite seu usuário"
              disabled={loading}
              required
              autoComplete="username"
            />
          </div>

          <div className="ds-form-group">
            <label className="ds-label" htmlFor="senha">Senha</label>
            <PasswordInput
              id="senha"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              placeholder="Digite sua senha"
              disabled={loading}
              required
              autoComplete="current-password"
            />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
            <label htmlFor="manter-conectado" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, fontSize: 13, cursor: 'pointer' }}>
              <input
                id="manter-conectado"
                type="checkbox"
                checked={manter}
                onChange={(e) => setManter(e.target.checked)}
                disabled={loading}
                style={{ width: 16, height: 16, accentColor: '#e1005b' }}
              />
              Manter conectado por 30 dias
            </label>
            <button
              type="button"
              className="ds-link"
              onClick={() => navigate('/RecuperarSenha')}
            >
              Esqueceu a senha?
            </button>
          </div>

          {erro && <div className="ds-alert ds-alert-error">{erro}</div>}

          <button
            type="submit"
            className="ds-btn ds-btn-primary ds-btn-full"
            disabled={loading}
          >
            {loading ? <><span className="ds-spinner" /> Entrando...</> : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
